<template>
  <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_162_5797)">
    <path d="M6.82535 0.641829L1.17868 10.0685C1.06226 10.2701 1.00066 10.4987 1.00001 10.7315C0.999353
    10.9643 1.05967 11.1932 1.17496 11.3955C1.29025 11.5978 1.4565 11.7663 1.65715 11.8844C1.85781 12.0025
    2.08588 12.0659 2.31868 12.0685H13.612C13.8448 12.0659 14.0729 12.0025 14.2735 11.8844C14.4742
    11.7663 14.6404 11.5978 14.7557 11.3955C14.871 11.1932 14.9313 10.9643 14.9307 10.7315C14.93
    10.4987 14.8684 10.2701 14.752 10.0685L9.10535 0.641829C8.9865 0.4459 8.81916 0.283909
    8.61948 0.171485C8.41979 0.0590613 8.1945 0 7.96535 0C7.73619 0 7.5109 0.0590613 7.31122 0.171485C7.11153 0.283909 6.94419 0.4459 6.82535 0.641829Z" :fill="cor"/>
    <path d="M8 3.92889V6.59556" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8 9.26221H8.00667" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <defs>
    <clipPath id="clip0_162_5797">
    <rect width="16" height="12" fill="white"/>
    </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
 name: 'MySVGComponent',
 props: {
    cor: {
      type: String,
      default: '#ff0000 '
    }
  },

}
</script>

<style lang="scss" scoped>
svg {
  position: absolute;
  top: 27px;
  left: 15px;
}
</style>
